import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import type { GetInvestigationInsightsPayload, InsightData, InsightsByState } from './insight-findings.types';
import { groupInsightsByState } from './insight-findings.utils';

export const insightFindingsApiSlice = createApi({
  reducerPath: 'insightFindingsApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => ({
    getInsightById: builder.query<InsightData, string>({
      query: (insightId) => `/api/insight/v2/${insightId}`,
    }),
    getInvestigationInsights: builder.query<InsightsByState, GetInvestigationInsightsPayload>({
      query: ({ investigationId }) => ({
        url: `/api/insight/v2/investigation/${investigationId}`,
        method: 'GET',
      }),
      transformResponse: groupInsightsByState,
    }),
  }),
});

export const { useGetInsightByIdQuery, useGetInvestigationInsightsQuery } = insightFindingsApiSlice;
